import styled from 'styled-components';

// Higiene 2026-07-07 (Task 1 refactor): `Container` e `InfoMessage` difieren
// en CSS real de sus homónimos consolidados en ../MainStyledComponents
// (aquí sin flex/height/width, e `InfoMessage` sin text-align/padding) —
// quedan locales para no cambiar el render de los estados de mensaje.

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.m};
  }
`;

export const InfoMessage = styled.p`
  color: ${({ theme }) => theme.colors.greyDark};
  font-size: ${({ theme }) => theme.fontSize.M};
  margin: 0;
`;
